import { useEffect, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import visibleImg from "../../../../picture/Visible.png";

const styles = {
  cell: { padding: "5px", textAlign: "center", fontSize: "14px" },
  button: { padding: "10px 20px" }
};

const LZOModal = ({ handleConfirm, handleCancel, lzo, allLzo }) => {
  const [checkedLzo, setCheckedLzo] = useState(lzo);
  const [isCheckedAll, setIsCheckedAll] = useState(false);

  useEffect(() => { setCheckedLzo(lzo); }, [lzo]);

  const handleCheckRow = (item) => {
    setCheckedLzo(prev =>
      prev.find(ch => ch.id === item.id) ? prev.filter(r => r.id !== item.id) : [...prev, item]
    );
  };

  const handleCheckAll = () => {
    setCheckedLzo(isCheckedAll ? [] : allLzo);
    setIsCheckedAll(prev => !prev);
  };

  return (
    <div style={{ display: "flex", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", justifyContent: "center", alignItems: "center", zIndex: 1000 }}>
      <div style={{ backgroundColor: "white", width: "60%", borderRadius: "10px", padding: "40px" }}>
        <div style={{ width: "100%", maxHeight: "500px", overflowY: "auto" }}>
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th style={styles.cell}><input type="checkbox" checked={isCheckedAll} onChange={handleCheckAll} style={{ width: "25px" }} /></th>
                <th style={styles.cell}>Rb.</th>
                <th style={{ ...styles.cell, width: "50%" }}>ЛИЧНА ЗАШТИТНА ОПРЕМА</th>
                <th style={{ ...styles.cell, width: "10%" }}>СТАНДАРД</th>
                <th style={styles.cell}>ИЗД</th>
                <th style={styles.cell}>МАГ</th>
                <th style={styles.cell}>СУМ</th>
                <th style={styles.cell}>ОТП</th>
              </tr>
            </thead>
            <tbody>
              {allLzo.map((item, i) => (
                <tr key={item.id}>
                  <td style={styles.cell}><input type="checkbox" checked={!!checkedLzo.find(it => it.id === item.id)} onChange={() => handleCheckRow(item)} style={{ width: "25px" }} /></td>
                  <td style={styles.cell}>{i + 1}.</td>
                  <td style={styles.cell}>{item.naziv}</td>
                  <td style={styles.cell}>{item.standard}</td>
                  <td style={styles.cell}>{item.izd}</td>
                  <td style={styles.cell}>{item.mag}</td>
                  <td style={styles.cell}>{item.izd + item.mag}</td>
                  <td style={styles.cell}>{item.otp}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "40px" }}>
          <div onClick={handleCancel} style={{ width: "10vw", height: "40px" }}>
            <Button activation={true} style={styles.button}><span style={{ fontWeight: "bold" }}>ОДУСТАНИ</span></Button>
          </div>
          <div onClick={() => handleConfirm(checkedLzo)} style={{ width: "10vw", height: "40px" }}>
            <Button activation={true} style={styles.button}><span style={{ fontWeight: "bold" }}>САЧУВАЈ</span></Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LZOModal;